<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">
        <div class="text-xs-center">
          <v-avatar size='40px'>
            <img :src='photoURL' alt='avatar'>
          </v-avatar>
          <div  class='text-xs-center'>
            <h2 class='headline'>{{ teamObj.teamName }}</h2>
          </div>
        </div>
      </v-flex>


  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-list two-line>
          <template v-for="item in items">
            <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
            <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
            <v-list-tile avatar v-else v-bind:key="item.title" @click="" download>
              <v-list-tile-avatar>
                <img v-bind:src="item.avatar">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
      <v-btn :to='this.to'>メンバーを追加</v-btn>
    </v-flex>
  </v-layout>
    </v-flex>

  </v-layout>
</v-container>
</template>


<script>
  import firebase from 'firebase'
  export default {
    data () {
      return {
        items: [
          { header: 'Members' }
          // { avatar: 'https://vuetifyjs.com/static/doc-images/lists/1.jpg', title: 'Brunch this weekend?', subtitle: "<span class='grey--text text--darken-2'>Ali Connors</span> — I'll be in your neighborhood doing errands this weekend. Do you want to hang out?" },
          // { divider: true, inset: true },
          // { avatar: 'https://vuetifyjs.com/static/doc-images/lists/1.jpg', title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>', subtitle: "<span class='grey--text text--darken-2'>to Alex, Scott, Jennifer</span> — Wish I could come, but I'm out of town this weekend." },
          // { divider: true, inset: true },
          // { avatar: 'https://vuetifyjs.com/static/doc-images/lists/1.jpg', title: 'Oui oui', subtitle: "<span class='grey--text text--darken-2'>Sandra Adams</span> — Do you have Paris recommendations? Have you ever been?" }
        ],
        teamObj: {},
        to: '/team/' + this.$route.params.id + '/invite'
      }
    },
    created () {
      this.entries()
      this.getTeam()
      // console.log(this.item.capacity, '<- capacity | length ->', this.teams.length)
      // this.remaining = this.item.capacity - this.teams.length
    },
    methods: {
      entries: function () {
        var db = firebase.firestore()
        console.log(this.$route.params.id)
        let query = db.collection('m2m_teams_users').where('team', '==', this.$route.params.id)
        query.get().then(querySnapshot => {
          querySnapshot.forEach(documentSnapshot => {
            var obj = documentSnapshot.data()
            // user
            var docRef = db.collection('users').doc(obj.user)
            docRef.get().then(doc => {
              if (doc.exists) {
                // Document read successfully.
                // this.items.push(doc.data())
                let user = doc.data()
                this.items.push({ avatar: user.photoURL, title: user.name, subtitle: '', to: '' })
                console.log('inner')
              } else {
                console.log('No such document!')
              }
            }).catch(function (error) {
              console.log('Error getting document:', error)
            })
            console.log(obj)
            console.log(docRef)
          })
        })
        console.log('------')
      },
      getTeam: function () {
        console.log('id->' + this.$route.params.id)
        var db = firebase.firestore()
        var docRef = db.collection('teams').doc(this.$route.params.id)

        // Read the document.
        docRef.get().then(doc => {
          if (doc.exists) {
            // Document read successfully.
            this.teamObj = doc.data()
            console.log('this->' + this.teamObj.teamName)
          } else {
            console.log('No such document!')
          }
        }).catch(function (error) {
          console.log('Error getting document:', error)
        })
      }
    }
  }
</script>


<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/team/Members.vue